import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useBoundStore } from '@/store/useBoundStore'

export function Login() {
	const login = useBoundStore((state) => state.login)
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [loading, setLoading] = useState(false)

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setError(null)
		setLoading(true)

		try {
			await login({ email, password })
			toast.success('Sesión iniciada correctamente')
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : 'Error al iniciar sesión'
			setError(errorMessage)
		} finally {
			setLoading(false)
		}
	}

	return (
		<div className="w-full max-w-lg space-y-6 px-4">
			<Card className="w-full">
				<CardHeader>
					<CardTitle>Iniciar sesión</CardTitle>
					<CardDescription>Ingresa tus credenciales para acceder</CardDescription>
				</CardHeader>
				<CardContent>
					<form onSubmit={handleSubmit} className="space-y-4">
						<div className="space-y-2">
							<Label htmlFor="email">Email</Label>
							<Input
								id="email"
								type="email"
								placeholder="Ingresa tu email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
								disabled={loading}
							/>
						</div>
						<div className="space-y-2">
							<Label htmlFor="password">Contraseña</Label>
							<Input
								id="password"
								type="password"
								placeholder="Ingresa tu contraseña"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
								disabled={loading}
							/>
						</div>
						{error && (
							<div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md p-3">
								{error}
							</div>
						)}
						<Button type="submit" className="w-full" disabled={loading}>
							{loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
						</Button>
					</form>
				</CardContent>
			</Card>
		</div>
	)
}
